/**
 * Maps an OSM level hint to a schematic render height (meters, y-up).
 * These are documented model assumptions, NOT survey values: the OSM `level`
 * tag encodes relative intersection order and may not be read as exact depth.
 */
export function levelToHeight(level: number | null | undefined): number {
  if (level == null) return 0;
  if (level < 0) return level <= -3 ? -20 : level === -2 ? -16 : -12;
  if (level > 0) return level * 6;
  return 0;
}
